import { Card, CardContent, ProgressBar, Text } from "@prismicio/editor-ui"

import type {
  OnboardingStep,
  OnboardingStepId,
  OnboardingTracking,
} from "../../service"
import { OnboardingTutorial } from "../components/OnboardingTutorial"
import { OnboardingProgressStepper } from "./OnboardingProgressStepper"

interface OnboardingCardProps {
  steps: OnboardingStep[]
  completedSteps: string[]
  tutorialLink?: string
  tracking: OnboardingTracking
  onToggleStep: (step: OnboardingStep) => Promise<void>
  onClose?: () => void
  stepOverrides?: Partial<Record<OnboardingStepId, () => void>>
}
export function OnboardingCard(props: OnboardingCardProps) {
  const {
    steps,
    completedSteps,
    tutorialLink,
    tracking,
    onToggleStep,
    onClose,
    stepOverrides,
  } = props

  const isComplete = completedSteps.length === steps.length

  return (
    <Card
      variant={isComplete ? "elevated" : "animated-light"}
      paddingBlock={16}
      onClose={onClose}
    >
      <CardContent>
        <div>
          <Text variant="bold">
            {`Build your first page in ${steps.length.toString()} simple steps`}
          </Text>
          <Text color="grey11" variant="small">
            Render a live page with content coming from Prismic.
          </Text>
        </div>
        <ProgressBar
          value={completedSteps.length}
          max={steps.length}
          displayLabel
          getValueLabel={(value, max) => `${value}/${max}`}
        />
        <OnboardingProgressStepper
          steps={steps}
          completedSteps={completedSteps}
          onToggleStep={onToggleStep}
          tracking={tracking}
          stepOverrides={stepOverrides}
        />
        {tutorialLink && (
          <OnboardingTutorial href={tutorialLink} tracking={tracking} />
        )}
      </CardContent>
    </Card>
  )
}
